module.exports = __webpack_public_path__ + "static/img/jy_b.84f7d03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jy_b.png
// module id = Hv6j
// module chunks = 1